import React from 'react';

export function WhatsAppIcon({ size = 18, className = '', style = {} }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
      style={{ display: 'inline-block', verticalAlign: 'middle', shrink: 0, ...style }}
      aria-hidden="true"
    >
      <path d="M17.472 14.382c-.301-.15-1.78-.878-2.056-.978-.276-.1-.476-.15-.677.15-.2.301-.777.979-.953 1.18-.175.2-.351.225-.652.075-.3-.15-1.268-.468-2.416-1.492-.893-.798-1.496-1.784-1.671-2.085-.176-.3-.019-.463.132-.612.136-.134.301-.35.452-.525.15-.176.2-.301.301-.502.1-.2.05-.376-.025-.526-.075-.15-.677-1.63-.928-2.235-.245-.588-.493-.509-.677-.518-.175-.008-.376-.01-.577-.01-.2 0-.526.075-.802.376-.276.301-1.053 1.028-1.053 2.508 0 1.48 1.078 2.909 1.229 3.109.15.2 2.121 3.238 5.138 4.542.718.31 1.278.495 1.716.634.721.229 1.376.197 1.895.12.577-.087 1.78-.727 2.03-1.43.251-.703.251-1.304.176-1.43-.076-.126-.276-.201-.577-.351zM12.042 21.898c-1.79 0-3.543-.48-5.08-1.39l-.364-.216-3.774.99 1.008-3.678-.236-.376A9.873 9.873 0 012.17 12.04c0-5.442 4.428-9.87 9.875-9.87 2.637 0 5.115 1.028 6.98 2.893a9.814 9.814 0 012.89 6.98c0 5.443-4.43 9.875-9.873 9.875zm8.384-18.257A11.796 11.796 0 0012.042 0C5.402 0 .003 5.399.003 12.042c0 2.12.553 4.19 1.605 6.012L0 24l6.108-1.603a11.988 11.988 0 005.934 1.55h.005c6.64 0 12.037-5.399 12.04-12.045 0-3.216-1.252-6.24-3.528-8.514z" />
    </svg>
  );
}

export default WhatsAppIcon;
